// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3bcRR","imageUploader":"EGiftCard_imageUploader__2hhpo"};